import { render, staticRenderFns } from "./TruckInformation.vue?vue&type=template&id=331f9098"
import script from "./TruckInformation.vue?vue&type=script&lang=js"
export * from "./TruckInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports